// extracted by mini-css-extract-plugin
export default {"item":"expander-module___item___d889b99e","label":"expander-module___label___ae52c7b2","arrowExpanded":"expander-module___arrowExpanded___f340aff1"};